"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseServiceManagerClient = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const WarehouseApiClient_1 = require("./WarehouseApiClient");
const commons_utils_1 = require("@deliverr/commons-utils");
const client_auth_1 = require("@deliverr/client-auth");
const commons_objects_1 = require("@deliverr/commons-objects");
class WarehouseServiceManagerClient extends WarehouseApiClient_1.WarehouseApiClient {
    constructor(config = {}) {
        const WAREHOUSE_SERVICE_URL = (0, commons_utils_1.getEnvString)("WAREHOUSE_SERVICE_MANAGER_URL");
        const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
        super({
            ...config,
            baseURL: `${config.baseURL || WAREHOUSE_SERVICE_URL}`,
            authEngine: commons_objects_1.AuthEngine.COGNITO_INTERNAL,
            tokenRefreshFn: tokenHandler.getTokenFn(),
        });
        if (!WAREHOUSE_SERVICE_URL) {
            commons_logs_1.log.warn("WAREHOUSE_SERVICE_MANAGER_URL environment variable is not set in WarehouseServiceManagerClient");
        }
    }
    /**
     * Returns ack for accepting sku audit request
     * @param request - list of up to 1000 skus to be audited
     */
    async submitSkuAudit(request) {
        try {
            return await this.post("/serial-audit/auditSkus", request);
        }
        catch (error) {
            return this.handleError("submitSkuAudit", error);
        }
    }
    /**
     * Returns Inventory audit cron config
     */
    async getInventoryAuditCronConfig(warehouseId) {
        try {
            return await this.get("/config-manager/v1/inventory-audit-cron-config", {
                warehouseId,
            });
        }
        catch (error) {
            return this.handleError("getInventoryAuditCronConfig", error);
        }
    }
    /**
     * Saves Inventory audit cron config
     */
    async saveInventoryAuditCronConfig(object) {
        try {
            return await this.post("/config-manager/v1/inventory-audit-cron-config", { inventoryAuditCronConfig: object });
        }
        catch (error) {
            return this.handleError("saveInventoryAuditCronConfig", error);
        }
    }
    /**
     * Returns replayId for accepting replay movement request
     * @param request - warehouseId, fromTime, toTime
     */
    async submitReplayMovements(request) {
        try {
            return await this.post("/inventory-movement/replayMovements", request);
        }
        catch (error) {
            return this.handleError("submitReplayMovements", error);
        }
    }
}
exports.WarehouseServiceManagerClient = WarehouseServiceManagerClient;
//# sourceMappingURL=WarehouseServiceManagerClient.js.map